import { render, staticRenderFns } from "./ProjectPOABudgetFill.vue?vue&type=template&id=2bbabb00"
import script from "./ProjectPOABudgetFill.vue?vue&type=script&lang=js"
export * from "./ProjectPOABudgetFill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports